export default __webpack_public_path__ + "static/media/mine.min.5f9a0249.png";